/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "scan_planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface TrajectoryMotionInfo {
  hasLargeHeadingChange: boolean;
  speed: number;
  distanceMargin: number;
  headingRateLimit: number;
  gimbalPitchRateLimit: number;
  maxPathSpeed: number;
}

function createBaseTrajectoryMotionInfo(): TrajectoryMotionInfo {
  return {
    hasLargeHeadingChange: false,
    speed: 0,
    distanceMargin: 0,
    headingRateLimit: 0,
    gimbalPitchRateLimit: 0,
    maxPathSpeed: 0,
  };
}

export const TrajectoryMotionInfo = {
  encode(message: TrajectoryMotionInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.hasLargeHeadingChange === true) {
      writer.uint32(8).bool(message.hasLargeHeadingChange);
    }
    if (message.speed !== 0) {
      writer.uint32(21).float(message.speed);
    }
    if (message.distanceMargin !== 0) {
      writer.uint32(29).float(message.distanceMargin);
    }
    if (message.headingRateLimit !== 0) {
      writer.uint32(37).float(message.headingRateLimit);
    }
    if (message.gimbalPitchRateLimit !== 0) {
      writer.uint32(45).float(message.gimbalPitchRateLimit);
    }
    if (message.maxPathSpeed !== 0) {
      writer.uint32(53).float(message.maxPathSpeed);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TrajectoryMotionInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrajectoryMotionInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.hasLargeHeadingChange = reader.bool();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.speed = reader.float();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.distanceMargin = reader.float();
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.headingRateLimit = reader.float();
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.gimbalPitchRateLimit = reader.float();
          continue;
        case 6:
          if (tag !== 53) {
            break;
          }

          message.maxPathSpeed = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TrajectoryMotionInfo {
    return {
      hasLargeHeadingChange: isSet(object.hasLargeHeadingChange)
        ? globalThis.Boolean(object.hasLargeHeadingChange)
        : false,
      speed: isSet(object.speed) ? globalThis.Number(object.speed) : 0,
      distanceMargin: isSet(object.distanceMargin) ? globalThis.Number(object.distanceMargin) : 0,
      headingRateLimit: isSet(object.headingRateLimit) ? globalThis.Number(object.headingRateLimit) : 0,
      gimbalPitchRateLimit: isSet(object.gimbalPitchRateLimit) ? globalThis.Number(object.gimbalPitchRateLimit) : 0,
      maxPathSpeed: isSet(object.maxPathSpeed) ? globalThis.Number(object.maxPathSpeed) : 0,
    };
  },

  toJSON(message: TrajectoryMotionInfo): unknown {
    const obj: any = {};
    if (message.hasLargeHeadingChange === true) {
      obj.hasLargeHeadingChange = message.hasLargeHeadingChange;
    }
    if (message.speed !== 0) {
      obj.speed = message.speed;
    }
    if (message.distanceMargin !== 0) {
      obj.distanceMargin = message.distanceMargin;
    }
    if (message.headingRateLimit !== 0) {
      obj.headingRateLimit = message.headingRateLimit;
    }
    if (message.gimbalPitchRateLimit !== 0) {
      obj.gimbalPitchRateLimit = message.gimbalPitchRateLimit;
    }
    if (message.maxPathSpeed !== 0) {
      obj.maxPathSpeed = message.maxPathSpeed;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TrajectoryMotionInfo>, I>>(base?: I): TrajectoryMotionInfo {
    return TrajectoryMotionInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrajectoryMotionInfo>, I>>(object: I): TrajectoryMotionInfo {
    const message = createBaseTrajectoryMotionInfo();
    message.hasLargeHeadingChange = object.hasLargeHeadingChange ?? false;
    message.speed = object.speed ?? 0;
    message.distanceMargin = object.distanceMargin ?? 0;
    message.headingRateLimit = object.headingRateLimit ?? 0;
    message.gimbalPitchRateLimit = object.gimbalPitchRateLimit ?? 0;
    message.maxPathSpeed = object.maxPathSpeed ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
